let REACT_APP_API_URL = process.env.REACT_APP_API_URL;
if (!process.env.REACT_APP_API_URL) REACT_APP_API_URL = process.env.REACT_APP_API_DEV_URL;

class HttpError extends Error {
  constructor(message, status) {
    super(message);
    this.name = 'HttpError';
    this.status = status;
  }
}

const handleResponse = async (response, customError) => {
  if (!response.ok) {
    let errorMsg = customError || `Request failed with status ${response.status}`;
    try {
        const errorBody = await response.json();
        errorMsg = errorBody.message || errorMsg;
    } catch (e) {
        // ignore if response is not json
    }
    throw new HttpError(errorMsg, response.status);
  }

  if (response.status === 204) {
    return {};
  }
  
  try {
    return await response.json();
  } catch (error) {
    return {};
  }
};

export const createCommunity = async (community) => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/communities`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(community),
  });
  return handleResponse(response, 'Falha ao criar comunidade');
};

export const editCommunity = async (id, editCommunity) => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/communities/${id}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(editCommunity),
  });
  return handleResponse(response, 'Falha ao editar comunidade');
};

export const getCommunityById = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/communities/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
  });
  return handleResponse(response, 'Falha ao buscar comunidade');
};

export const deleteCommunity = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/communities/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
  });
  return handleResponse(response, 'Falha ao deletar comunidade');
};

export const getCommunityFullCalendar = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/communities/${id}/full-calendar`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
  });
  return handleResponse(response, 'Falha ao buscar calendário completo da comunidade');
};

export const getCommunitiesByUser = async (userId) => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/communities/user/${userId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
  });
  return handleResponse(response, 'Falha ao buscar comunidades por usuário');
};

export const createCalendar = async (contentCalendar) => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/calendars`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(contentCalendar),
  });
  return handleResponse(response, 'Falha ao criar calendário');
};

export const getCalendarByCommunityId = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/calendars/community/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
  });
  return handleResponse(response, 'Falha ao buscar calendário por id da comunidade');
};

export const deleteCalendar = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/calendars/${id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
  });
  return handleResponse(response, 'Falha ao deletar calendário');
};

export const createCalendarWeek = async (calendarWeek) => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/calendar-weeks`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(calendarWeek)
  });
  return handleResponse(response, 'Falha ao criar semana do calendário');
};

export const getWeeksByCommunityId = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/calendar-weeks/calendar/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
  });
  return handleResponse(response, 'Falha ao buscar semanas por id da comunidade');
};

export const createWeekPost = async (postWeek) => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/week-posts`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(postWeek)
  });
  return handleResponse(response, 'Falha ao criar post da semana');
};

export const editWeekPost = async (id, postWeek) => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/week-posts/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(postWeek)
  });
  return handleResponse(response, 'Falha ao editar post da semana');
};

export const getWeekPostsByWeekId = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(REACT_APP_API_URL + `/dashboard/week-posts/week/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
  });
  return handleResponse(response, 'Falha ao buscar posts da semana por id da semana');
};